import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);
const getDefaultState = () => {
    return {
        token: '',
        user: {},
        meals: [],
        selectedYear: null,
        selectedWeek: null
    };
};
export default new Vuex.Store({
    strict: true,
    plugins: [createPersistedState({ storage: window.sessionStorage })],
    state: getDefaultState(),
    getters: {
        isLoggedIn: state => {
            return state.token;
        },
        isAdmin: state => {
            return !!state.user.admin;
        },
        getSelectedWeek: state => {
            return state.selectedWeek
        },
        getSelectedYear: state => {
            return state.selectedYear
        },
        getUser: state => {
            return state.user;
        },
        getMeals: state => {
            return state.meals
        }
    },
    mutations: {
        SET_MEALS: (state, meals) => {
            state.meals = meals
        },
        SET_SELECTED_WEEK: (state, week) => {
            state.selectedWeek = week
        },
        SET_SELECTED_YEAR: (state, year) => {
            state.selectedYear = year
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        SET_PLAN_USER: (state, planUser) => {
            state.user.planUsers.push(planUser)
        },
        RESET: state => {
            Object.assign(state, getDefaultState());
            delete Axios.defaults.headers.common['Authorization'];
        }
    },
    actions: {
        login: ({ commit }, { token, user }) => {
            commit('SET_TOKEN', token);
            commit('SET_USER', user);
            // set auth header
            Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },
        logout: ({ commit }) => {
            commit('RESET', '');
        },
        addPlanUser: ({ commit }, { planUser }) => {
            commit('SET_PLAN_USER', planUser)
        }
    }
});
